package com.sweetlime.bingeamigo

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

data class ShowDeepLink(val showId: Int, val showName: String)

object DeepLinkHandler {
    private val _pending = MutableStateFlow<ShowDeepLink?>(null)
    val pending: StateFlow<ShowDeepLink?> = _pending

    fun navigateTo(link: ShowDeepLink) {
        _pending.value = link
    }

    fun consume() {
        _pending.value = null
    }
}